import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import { PARTICIPANT_JOINED, PARTICIPANT_UPDATED } from '../base/participants/actionTypes';
import { getParticipantById, getUserIdByOccupantId } from '../base/participants/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { getSenderByUserId } from './functions';
import { addRecentSender, disableVTChatModeration, enableVTChatModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected } from './slice';
/**
 * Registers a change handler for state['features/base/conference'].conference to
 * set the event listeners needed for the A/V moderation feature to operate.
 */
StateListenerRegistry.register((state) => state['features/base/conference'].conference, (conference, { dispatch }, previousConference) => {
    if (conference && !previousConference) {
        // Local participant is allowed to unmute
        conference.on(JitsiConferenceEvents.VT_CHAT_MODERATION_APPROVED, ({ requestOccupantJid }) => {
            dispatch(localParticipantApproved());
            // Example notification code (commented out):
            // if (requestOccupantJid) {
            //     dispatch(showNotification({
            //         uid: 'ALLOW_TO_CHAT',
            //         titleKey: i18n.t('notify.allowToChat')
            //     }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
            // }
        });
        conference.on(JitsiConferenceEvents.VT_CHAT_MODERATION_REJECTED, () => {
            dispatch(localParticipantRejected());
        });
        conference.on(JitsiConferenceEvents.VT_CHAT_MODERATION_CHANGED, ({ enabled, actor }) => {
            enabled ? dispatch(enableVTChatModeration(actor)) : dispatch(disableVTChatModeration(actor));
        });
        // This is received by moderators
        conference.on(JitsiConferenceEvents.VT_CHAT_MODERATION_PARTICIPANT_APPROVED, ({ participant }) => {
            const { _id: jid } = participant;
            // Store in the whitelist
            dispatch(participantApproved({ jid }));
        });
        // This is received by moderators
        conference.on(JitsiConferenceEvents.VT_CHAT_MODERATION_PARTICIPANT_REJECTED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantRejected({ jid }));
        });
    }
});
MiddlewareRegistry.register(({ dispatch, getState }) => (next) => (action) => {
    const state = getState();
    switch (action.type) {
        case PARTICIPANT_UPDATED: {
            const { participant } = action;
            const { id, name, avatarURL } = participant;
            if (id && (name || avatarURL)) {
                const oldParticipant = getParticipantById(state, id);
                const userId = getUserIdByOccupantId(state, id);
                const oldSenderInfo = userId ? (getSenderByUserId(userId, state) || { senderAccId: userId }) : { senderAccId: userId };
                if (!oldParticipant?.local && userId) {
                    if (name && name !== oldParticipant?.name) {
                        dispatch(addRecentSender({
                            ...oldSenderInfo,
                            senderAccName: name
                        }));
                    }
                    if (avatarURL && avatarURL !== oldParticipant?.avatarURL) {
                        dispatch(addRecentSender({
                            ...oldSenderInfo,
                            senderAvatar: avatarURL
                        }));
                    }
                }
            }
            break;
        }
        case PARTICIPANT_JOINED: {
            const { participant } = action;
            const { id, name, avatarURL } = participant;
            if (id && (name || avatarURL)) {
                const oldParticipant = getParticipantById(state, id);
                const userId = getUserIdByOccupantId(state, id);
                const oldSenderInfo = userId ? (getSenderByUserId(userId, state) || { senderAccId: userId }) : { senderAccId: userId };
                if (!oldParticipant?.local && userId) {
                    if (name && name !== oldParticipant?.name) {
                        dispatch(addRecentSender({
                            ...oldSenderInfo,
                            senderAccName: name
                        }));
                    }
                    if (avatarURL && avatarURL !== oldParticipant?.avatarURL) {
                        dispatch(addRecentSender({
                            ...oldSenderInfo,
                            senderAvatar: avatarURL
                        }));
                    }
                }
            }
            break;
        }
    }
    return next(action);
});
